import { Box } from "@mui/material";
import { platform } from "../../config";
import Demo from "./Demo";
import Header from "./Header";
import Hero from "./Hero";
import LanguageToggle from "./LanguageToggle";
import Register from "./Register";
import SignIn from "./SignIn";

export default function Welcome() {
  const registerAvailable = platform !== "ios";

  return (
    <Box sx={{ bgcolor: "grey.900", py: { lg: 4 } }}>
      <Box
        sx={{
          height: (theme) => ({
            xs: "100vh",
            lg: `calc(100vh - ${theme.spacing(8)})`,
          }),
          mx: { lg: "auto" },
          maxWidth: (theme) => ({
            lg: `calc(${theme.breakpoints.values.lg}px - ${theme.spacing(4)})`,
          }),
          borderRadius: { lg: 1 },
          boxShadow: { lg: 5 },
          display: "flex",
          flexDirection: "column",
          position: "relative",
          overflow: "auto",
        }}
      >
        <Hero />
        <Header />
        <Box
          sx={{
            color: "common.white",
            zIndex: 1,
            display: "flex",
            justifyContent: "flex-end",
            px: 4,
            pt: 2,
            gap: 2,
          }}
        >
          <LanguageToggle />
        </Box>
        <Box
          component="main"
          sx={{
            position: "relative",
            marginTop: "auto",
            p: 4,
            zIndex: 1,
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gap: (theme) => theme.spacing(2),
              gridTemplateColumns: {
                md: `repeat(${registerAvailable ? 3 : 2}, 1fr)`,
              },
            }}
          >
            <SignIn />
            {registerAvailable && <Register />}
            <Demo />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
